import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import DashBoardCreateUpdateForm from "./DashBoardCreateUpdateForm";
import localStrings from "../../../localStrings";
import {MODE_CREATE} from "../../../components/CrudFrom/GeneralEditor";
import {Link as RouterLink} from "react-router-dom";
import {dashboardBaseRoute, dashboardListRoute} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PageWithTitle from "../../../components/pages/pageWithTitle";

const DashBoardAddView = () => {

  function getMainButtons() {
    return (


      <RouterLink to={'/' + dashboardBaseRoute + '/' + dashboardListRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <ArrowBackIcon />
            </SvgIcon>
          )}
        >
          {localStrings.backToList}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.createDashBoard} mainButtons={getMainButtons()}>
      <DashBoardCreateUpdateForm modeEdit={MODE_CREATE}/>
    </PageWithTitle>
  );
};

export default DashBoardAddView;
